"use client"; // Indicate this is a client component

import { Code, FileUp } from "lucide-react";
import { useEffect } from "react";
import PageLayout from "@/components/_shared/PageLayout";
// import Header from "@/components/startseite/Header"; // Entfernt, da PageLayout den Header übernimmt
import ToolGrid from "@/components/startseite/ToolGrid";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";
import { usePageSettings } from "@/lib/cookies";

// Define the Tools and Categories (can be moved to a config file later)
export const APP_CATEGORIES = [
	{
		name: "KI-Tools",
		tools: [
			{
				id: "bulletpoints",
				title: "Bulletpoints",
				description: "Bulletpoints verbessern",
				href: "/bp",
			},
			{
				id: "umformulieren",
				title: "Umformulieren",
				description: "Sätze technisch, kundisch oder neutral umschreiben",
				href: "/umformulieren",
			},
		],
	},
	{
		name: "Generatoren",
		tools: [
			{
				id: "totp",
				title: "TOTP Generator",
				description: "MFA-/ TOTP-Codes generieren",
				href: "/totp",
			},
			{
				id: "passwort",
				title: "Passwort Generator",
				description: "Sichere Passwörter generieren",
				href: "/pw",
			},
			{
				id: "qrcode",
				title: "QR-Code Generator",
				description: "QR-Codes für Links und Text erstellen",
				href: "/qr",
			},
		],
	},
	{
		name: "Share-Tools",
		tools: [
			{
				id: "link-share",
				title: "Link-Share",
				description: "Lange URLs in kurze Links umwandeln",
				href: "/link",
			},
			{
				id: "text-share",
				title: "Text-Share",
				description: "Text in geschützten Räumen teilen",
				href: "/text",
			},
			{
				id: "file-share", // New File-Share tool
				title: "File-Share",
				description: "Dateien in geschützten Räumen teilen",
				href: "/file",
				icon: FileUp, // Assign icon
			},
		],
	},
	{
		name: "Sonstiges",
		tools: [
			{
				id: "skripte",
				title: "Skripte",
				description: "Windows & Microsoft 365",
				href: "/skripte",
				icon: Code,
			},
		],
	},
];

export default function Startseite() {
	useEffect(() => {
		document.title = "labi.dev";
	}, []);

	const { settings, updateSettings } = usePageSettings<{
		open: string[];
	}>("eingeklapptDashboard", {
		open: ["KI-Tools", "Generatoren", "Share-Tools", "Skripte"],
	});

	return (
		<PageLayout isStartseite={true} title="labi.dev">
			{" "}
			{/* title hier explizit für Klarheit, obwohl isStartseite es steuert */}
			{/* Der folgende Block wird entfernt, da der PageLayout den Header rendert */}
			{/* <div className="flex justify-between items-center mb-8">
<div className="logo-highlight">
<h1 className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">
labi.dev
</h1>
</div>
<Header />
</div> */}
			<main className="mt-6">
				<Accordion
					className="space-y-3"
					defaultValue={settings.open}
					onValueChange={(value) =>
						updateSettings({ open: Array.isArray(value) ? value : [value] })
					}
					type="multiple"
				>
					{APP_CATEGORIES.map((cat) => (
						<AccordionItem key={cat.name} value={cat.name}>
							<div className="rounded-xl bg-white/60 shadow-sm backdrop-blur-sm dark:bg-gray-800/60">
								<AccordionTrigger className="px-4">
									<span className="font-semibold text-gray-800 text-base dark:text-gray-100">
										{cat.name}
									</span>
								</AccordionTrigger>
								<AccordionContent>
									<div className="px-4 pb-4">
										<ToolGrid tools={cat.tools} />
									</div>
								</AccordionContent>
							</div>
						</AccordionItem>
					))}
				</Accordion>
			</main>
		</PageLayout>
	);
}
